<template>
    <div class="modal-content">
        <div
            class="border-0 modal-header justify-content-center text-center p-4"
        >
            <modal-close
                :disabled="requiredConfirmation && !read"
                :on-close="closeModal"
            />
            <h5 class="h3 modal-title" id="staticBackdropLabel">
                {{ alert.title }}
            </h5>
        </div>
        <div class="modal-body" v-html="alert.body"></div>
        <div
            class="border-0 my-3 modal-footer justify-content-center flex-column"
        >
            <div v-if="requiredConfirmation">
                <ui-checkbox-input
                    class="font-weight-medium"
                    name="filter-1-1"
                    v-model="read"
                    :label="
                        `Zapoznałem się z treścią powyższego komunikatu <span class=text-danger>*</span>`
                    "
                />
                <div v-if="validationText" class="text-danger pl-4">
                    {{ validationText }}
                </div>
            </div>
            <button
                type="button"
                class="btn btn-secondary"
                :class="{ disabled: requiredConfirmation && !read }"
                data-dismiss="modal"
                @click="closeModal"
            >
                <span>Przejdź do platformy</span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            read: false,
            validationText: null
        }
    },
    computed: {
        alert() {
            return this.$store.getters.getFirstAlert
        },
        requiredConfirmation() {
            return this.alert.readingConfirmation
        }
    },
    methods: {
        closeModal() {
            if (this.read || !this.requiredConfirmation) {
                this.validationText = null
                this.$store
                    .dispatch('markOneNewsAsRead', this.alert.id)
                    .then(() => {
                        this.$store.dispatch('removeFirstAlert')
                        this.read = false
                        if (!this.alert) {
                            this.$store.dispatch('toggleModal', false)
                        }
                    })
            } else {
                this.validationText = 'Zaznacz to pole, aby przejść dalej'
            }
        }
    }
}
</script>
